export const SUPPORT_API_URL = 'ui/organization/support';
